import 'babel-polyfill';
import Event from './SystemEvents';
import Organized, { load, log, config as cfg } from './Organized';
import dotenv from 'dotenv';

dotenv.config({ path: `${process.cwd()}/.env` });

export default async (file) =>{
    Event.emit('beforeLoad',file, Organized);
}

export let $       = Organized;
export let dek     = Organized;
export let scope   = Organized;
export let config  = cfg;
export let success = log.success;
export let danger  = log.danger;
export let warning = log.warning;
export let info    = log.info;

export let add = (item, index) => {
    load(item, index);
}
